module.exports = __webpack_public_path__ + "static/media/1f46b.748285d4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/emoji/1f46b.svg
// module id = 642
// module chunks = 1